type AuthExpiredListener = () => void

const listeners = new Set<AuthExpiredListener>()
let lastNotifyAt = 0
const DEDUPE_MS = 800

export const subscribeAuthExpired = (listener: AuthExpiredListener) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export const notifyAuthExpired = () => {
  const now = Date.now()
  if (now - lastNotifyAt < DEDUPE_MS) {
    return
  }
  lastNotifyAt = now
  listeners.forEach((listener) => listener())
}
